import React from 'react';
import './ProjectItem.css';

import { Link } from 'react-router-dom';



const ProjectItem = (props) => {

  // Destructuring props
  const { id, image, title, category, project, className } = props;

  return (
    <div className={`project-item ${className}`} key={id}>
      <div className="project-content">

        {/* Project Image */}
        <img src={image} alt={title} />

        {/* Project Content */}
        <div className='content'>

          <div className='text'>

            {/* Project Category */}
            <p>{category}</p>

            {/* Link to the individual Project Detail Page */}
            <Link
              to={{
                pathname: '/Projects/' + title,
              }}
              state={project}
            >
              <h3>{title}</h3> {/* Project Title */}
            </Link>

          </div>

        </div>

      </div>
    </div>
  );
};

export default ProjectItem;